<!-- TODO: complete this componemt -->
<nav aria-label="Page navigation example">
    <ul class="pagination">
        <li class="page-item"
            ><a
                class="page-link"
                [class.disabled]="currentPage === 1"
                (click)="firstPage()"
                ><i class="glyphicon glyphicon-step-backward"></i></a
        ></li>
        <li class="page-item">
            <a
                class="page-link"
                [class.disabled]="currentPage === 1"
                (click)="prevPage()"
                ><i class="glyphicon glyphicon-menu-left"></i>
            </a>
        </li>
        @for (page of pages(); track page) {
            <li
                class="page-item"
                [class.active]="page === currentPage"
                (click)="onPageClick(page)">
                <a
                    class="page-link"
                    [class.disabled]="page === '…'"
                    >{{page}}</a
                >
            </li>
        }
        <li class="page-item"
            ><a
                class="page-link last"
                [class.disabled]="currentPage === pageCount"
                (click)="nextPage()"
                ><i class="glyphicon glyphicon-menu-right"></i></a
        ></li>
        <li class="page-item"
            ><a
                class="page-link last"
                [class.disabled]="currentPage === pageCount"
                (click)="lastPage()"
                ><i class="glyphicon glyphicon-step-forward"></i></a
        ></li>
    </ul>
</nav>
